const SECOND = 1;
const MINUTE = SECOND * 60;

// internals
export const MODE = {
	DEFAULT: 'default',
	EDIT:    'edit',
	VIEW:    'view',
};
export const DEVICE = {
	DESKTOP: 'desktop',
	MOBILE:  'mobile',
	TABLET:  'tablet',
};

export const MIN_ZOOM_DURATION = 60;

// tags
export const TAG_SIZE = 8;
export const TAG_SIZE_HOVERED = 12;
export const DOT_SIZE = 8;
export const DOT_SIZE_HOVERED = 12;
export const DOT_HOVERED_WIDTH_ADDITION = 16;
export const PILL_MERGE_DELTA = 10;
export const RULER_FORMAT_MINUTES = 'minutes';
export const RULER_FORMAT_MINUTES_SECONDS = 'seconds';

// ruler
export const RULER_SCALES = [
	// 120 min
	{
		TRIGGER: 120 * MINUTE,
		MAJOR:   60 * MINUTE,
		MEDIUM:  30 * MINUTE,
		MINOR:   15 * MINUTE,
		format:  RULER_FORMAT_MINUTES,
	},
	// 30 min
	{
		TRIGGER: 30 * MINUTE,
		MAJOR:   10 * MINUTE,
		MEDIUM:  2 * MINUTE,
		format:  RULER_FORMAT_MINUTES,
	},
	// default
	{
		TRIGGER: 10 * MINUTE,
		MAJOR:   5 * MINUTE,
		MEDIUM:  MINUTE,
		format:  RULER_FORMAT_MINUTES,
	},
	{
		TRIGGER: 3 * MINUTE,
		MAJOR:   MINUTE,
		MEDIUM:  10 * SECOND,
		format:  RULER_FORMAT_MINUTES_SECONDS,
	},
	{
		TRIGGER: MINUTE,
		MAJOR:   30 * SECOND,
		MEDIUM:  10 * SECOND,
		format:  RULER_FORMAT_MINUTES_SECONDS,
	},
	{
		TRIGGER: 5 * SECOND,
		MAJOR:   10 * SECOND,
		MEDIUM:  SECOND,
		format:  RULER_FORMAT_MINUTES_SECONDS,
	},
	{
		TRIGGER: SECOND,
		MAJOR:   5 * SECOND,
		MEDIUM:  SECOND,
		format:  RULER_FORMAT_MINUTES_SECONDS,
	},
];

// position dot
export const POSITION_DOT_SIZE = 14;

// edit
export const EDIT_BAR_MIN_WIDTH = 20;
export const EDIT_INTIAL_ZOOM_INTERVAL = 5 * MINUTE;
export const EDIT_SNAP_THROTTLE_INTERVAL = 200;
